<div class="cellWrapper">
    <div class="contactListStatusCircle" [style.background-color]="color" style="width: 16px; margin-right: 8px;"></div>
    <div>{{ params.data.State }}</div>
</div>